/**
 * @file
 * A JavaScript file containing the main menu functionality (small/large screen)
 *
 */

// JavaScript should be made compatible with libraries other than jQuery by
// wrapping it with an "anonymous closure". See:
// - https://drupal.org/node/1446420
// - http://www.adequatelygood.com/2010/3/JavaScript-Module-Pattern-In-Depth

(function (Drupal, $) {
  Drupal.behaviors.mainMenu = {
    attach: function (context) {
      "use strict";

      $(once("main-menu-processed", ".main-menu", context))
        .each(function () {
          var toggle_expand = document.getElementById("toggle-expand");
          var menu = document.getElementById("main-nav");
          var expand_menu = menu.querySelectorAll(".expand-sub");

          var darkBG = document.querySelector(".bg-dark");
          var body = document.querySelector("body");
          var header = document.querySelector(".header.mega-menu");
          var menuItem = menu.querySelectorAll(
            ".main-menu.level-0 > .main-menu__item"
          );

          const breakpoint = window.matchMedia("(max-width: 1223px)");

          if (!toggle_expand.classList.contains("click-events-added")) {
            // Mobile Menu Show/Hide.
            toggle_expand.addEventListener("click", function (e) {
              toggle_expand.classList.toggle("toggle-expand--open");
              menu.classList.toggle("main-nav--open");
              document.body.classList.toggle("main-nav-open");
              document.documentElement.style.setProperty(
                "--header-height",
                Math.round(
                  document
                    .querySelector(".header .grid-top")
                    .getBoundingClientRect().height
                ) + "px"
              );
            });

            breakpoint.addEventListener("change", () => {
              if (!breakpoint.matches) {
                toggle_expand.classList.remove("toggle-expand--open");
                menu.classList.remove("main-nav--open");
                document.body.classList.remove("main-nav-open");

                console.log("breakpoint changed");

                for (var i = 0; i < menuItem.length; i++) {
                  menuItem[i].classList.remove("is-open");
                  menuItem[i].style.display = "";

                  const subMenu = menuItem[i].querySelector(
                    ".main-menu--sub.main-menu--sub-open"
                  );
                  const expandSub = menuItem[i].querySelector(".expand-sub");
                  const menuItemLink = menuItem[i].querySelector(
                    ".main-menu__link--with-sub"
                  );

                  if (subMenu) {
                    subMenu.classList.remove("main-menu--sub-open");
                  }

                  if (expandSub) {
                    expandSub.style.display = "";
                  }
                  if (menuItemLink) {
                    menuItemLink.style.display = "";
                  }
                }
              }
            });

            // Expose mobile sub menu on click.
            for (var i = 0; i < expand_menu.length; i++) {
              expand_menu[i].addEventListener("click", function (e) {
                e.stopPropagation();

                var menu_item = e.currentTarget;
                var menu_item_parent = e.currentTarget.parentElement;
                var sub_menu = null;
                var sibling = menu_item.nextElementSibling;
                while (sibling && sub_menu == null) {
                  if (sibling.matches("ul")) sub_menu = sibling;
                  sibling = sibling.nextElementSibling;
                }

                menu_item_parent.classList.add("is-open");

                $(e.target).fadeOut(200);
                $(e.target).siblings(".main-menu__link").fadeOut(200);
                $(e.target)
                  .parent()
                  .siblings(".main-menu__item")
                  .fadeOut(200, function () {
                    setTimeout(() => {
                      sub_menu.classList.add("main-menu--sub-open");
                    }, 200);
                  });
              });
            }

            $(document).on(
              "click",
              ".main-menu__item.mobile-back-button",
              function () {
                $(this).parent().removeClass("main-menu--sub-open");
                setTimeout(() => {
                  $(this).parent().siblings().fadeIn(200);
                  $(this)
                    .closest(".main-menu__item.is-open")
                    .removeClass("is-open")
                    .siblings()
                    .fadeIn(200);
                }, 200);
              }
            );
          }
          toggle_expand.classList.add("click-events-added");

          for (var i = 0; i < menuItem.length; i++) {
            menuItem[i].addEventListener("mouseenter", function (e) {
              e.target.classList.add("is-hover");
              if (!e.target.classList.contains("search-wrapper")) {
                darkBG.classList.add("active");
                document.querySelector(".header").classList.add("bg-white");
              }
            });

            menuItem[i].addEventListener("mouseleave", function (e) {
              darkBG.classList.remove("active");
              document.querySelector(".header").classList.remove("bg-white");
            });
          }

          //Search
          $(
            ".main-menu.level-0 > .main-menu__item.search-wrapper a.main-menu__item-title-content"
          ).attr({role: "button", "aria-label":"Open search form"})

          $(once("main_menu_item", ".main-menu.level-0 > .main-menu__item.search-wrapper a.main-menu__item-title-content", context))
            .on("click", function (e) {
              e.target.classList.toggle("is-open");
              darkBG.classList.toggle("also-active");
              document
                .querySelector(".header")
                .classList.toggle("also-bg-white");
              $(e.target).siblings("ul.main-menu--sub").stop().slideToggle(250);

              if (e.target.classList.contains("is-open")) {
                $(e.target)
                  .siblings("ul.main-menu--sub")
                  .find("input.form-search")
                  .focus();
              }
            });

            $(
              ".footer .logo a"
            ).attr({"aria-label":"Home"})

            $(
              ".footer-credits__social .icons-group a"
            ).each(function(){
                const href = $(this).attr('href');
                const label = href.split(".")[1]
                $(this).attr({"aria-label": label});
            })

            $('a[href="/performance?tab=distribution-history"]').attr({"aria-label": "Distribution history" })
        }); // once

      // $(".stripe-deader__container")
      //   .once("stripe-ready")
      //   .each(function () {
      //     var adjustStripe = function () {
      //       var stripe = $(".stripe-deader__container");
      //       stripe.find("#block-personatypemenublock").css("width", "auto");
      //       if (stripe.outerHeight() > 40) {
      //         stripe.addClass("wrapped");
      //         stripe.find("#block-personatypemenublock").css("width", "100%");
      //       } else {
      //         stripe.removeClass("wrapped");
      //       }
      //     };
      //     $(window).on("resize", function () {
      //       adjustStripe();
      //     });
      //     adjustStripe();
      //   });
    },
  };
})(Drupal, jQuery);
